import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const roleApi = createApi({
  reducerPath: "roleApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_BASE_URL,
    credentials: "include",
  }),
  tagTypes: ["Role"],
  endpoints: (builder) => ({
    // ➕ Create Role
    addRole: builder.mutation({
      query: (newRole) => ({
        url: "/roles/create",
        method: "POST",
        body: newRole,
      }),
      invalidatesTags: ["Role"],
    }),

    // 📋 Get All Roles
    getAllRoles: builder.query({
      query: ({ page = 1, limit = 10, search = "", company, active } = {}) => {
        const params = { page, limit, q: search };
        if (company) params.company = company;
        if (typeof active === "boolean") params.active = active;
        return { url: "/roles", params };
      },
      providesTags: ["Role"],
    }),

    // 🆔 Get Role by ID
    getRoleById: builder.query({
      query: (id) => `/roles/${id}`,
      providesTags: (_res, _err, id) => [{ type: "Role", id }],
    }),

    // ✏️ Update Role
    updateRole: builder.mutation({
      query: ({ id, ...patch }) => ({
        url: `/roles/${id}`,
        method: "PUT",
        body: patch,
      }),
      invalidatesTags: ["Role"],
    }),

    // 🗑️ Delete Role
    deleteRole: builder.mutation({
      query: (id) => ({
        url: `/roles/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Role"],
    }),

    // 🟢 Activate Role
    activateRole: builder.mutation({
      query: (id) => ({
        url: `/roles/${id}/activate`,
        method: "PATCH",
      }),
      invalidatesTags: ["Role"],
    }),

    // 🔴 Deactivate Role
    deactivateRole: builder.mutation({
      query: (id) => ({
        url: `/roles/${id}/deactivate`,
        method: "PATCH",
      }),
      invalidatesTags: ["Role"],
    }),
  }),
});

export const {
  useAddRoleMutation,
  useGetAllRolesQuery,
  useGetRoleByIdQuery,
  useUpdateRoleMutation,
  useDeleteRoleMutation,
  useActivateRoleMutation,
  useDeactivateRoleMutation,
} = roleApi;

export default roleApi;
